import { find, matchesProperty } from 'lodash'
import { v4 } from 'uuid'

export const convertAudienceValue = (audience: any, targetingAggregates: any) => {
  // The converted 'audience' array
  const convertedAudienceValue = []

  for (const targetAudience of audience) {
    // The converted target audience within the 'audience' array
    const convertedTargetAudience = {
      filters: [],
      id: v4(),
      scimExpression: {
        type: targetAudience.type,
        value: targetAudience.value
      }
    }

    for (const [index, filterData] of targetAudience.audienceFilter.entries()) {
      let scimAttributeName
      // If the filter has an audience type that is in the format 'scimParentAttributeName.scimAttributeName',
      // remove the parent attribute name and save the scimAttributeName
      if (filterData.audienceType.includes('.')) {
        const values = filterData.audienceType.split('.')
        scimAttributeName = values[1]
      } else {
        scimAttributeName = filterData.audienceType
      }

      // Find the matching targetting aggregate in order to get the Display Name
      const targetingAggregate = find(targetingAggregates, matchesProperty('scimAttributeName', scimAttributeName))

      // The converted target audience filter
      const convertedFilter = {
        attribute: {
          displayName: targetingAggregate ? targetingAggregate.displayName : '',
          id: targetingAggregate ? targetingAggregate.id : '',
          scimAttributeName: scimAttributeName,
          type: typeof filterData.value,
          urn: filterData.urn
        },
        conditional: filterData.logicalOperator || 'and',
        id: v4(),
        operator: filterData.expressionOperator,
        scimExpression: {
          type: filterData.type,
          value:
            index === 0 // Do not include the logical operator if it is the first filter in the audience target
              ? `${filterData.urn} ${filterData.expressionOperator} ${JSON.stringify(filterData.value)}`
              : `${filterData.logicalOperator} ${filterData.urn} ${filterData.expressionOperator} ${JSON.stringify(
                  filterData.value
                )}`
        },
        value: filterData.value
      }

      // @ts-expect-error
      convertedTargetAudience.filters.push(convertedFilter)
    }

    convertedAudienceValue.push(convertedTargetAudience)
  }

  return convertedAudienceValue
}
